import merge from 'classnames';

import { MessageBoxProps } from './types';

import styles from './MessageBox.module.scss';

export const MessageBox = ({
  children,
  className,
  title,
  variant = 'information',
}: MessageBoxProps) => {
  return (
    <div
      className={merge(styles.message_box_wrapper, styles[variant], className)}
      data-testid="gafe-message-box"
    >
      {title && (
        <div className={styles.title_wrapper} data-testid="gafe-message-box-title">
          {title}
        </div>
      )}
      {children}
    </div>
  );
};
